// extracted by mini-css-extract-plugin
export default {"color__container":"Color_color__container__GX1uG","color__item":"Color_color__item__GtRKb"};